import {
  FARM_DIAGNOSTICS_LENS_BIO_VS_FINANCIAL,
  FARM_DIAGNOSTICS_LENS_FINANCIAL_EFFICIENCY,
  FARM_DIAGNOSTICS_LENS_ROTATION_EFFICIENCY,
  FARM_DIAGNOSTICS_LENS_WUE_TREND,
} from 'constants/uiConstants';

import type { FarmDiagnosticsLens } from '../../../redux/slices/InsightsSlice';
import type { InsightsScopeLevel } from 'pages/FarmsPage/Workspace/Insights/insightUtils';

// Kept out of useFarmsNavSync so it can be unit-tested without pulling in the
// service layer (axios) that the hook's data fetching depends on.

const VALID_LENSES: FarmDiagnosticsLens[] = [
  FARM_DIAGNOSTICS_LENS_ROTATION_EFFICIENCY,
  FARM_DIAGNOSTICS_LENS_WUE_TREND,
  FARM_DIAGNOSTICS_LENS_FINANCIAL_EFFICIENCY,
  FARM_DIAGNOSTICS_LENS_BIO_VS_FINANCIAL,
];

/** Farm and org (and crop) scopes compare paddocks, so they open Rotation efficiency. A paddock or plan opens its own WUE trend. */
export const getDefaultDiagnosticsLens = (
  scopeLevel: InsightsScopeLevel | undefined
): FarmDiagnosticsLens =>
  scopeLevel === 'paddock' || scopeLevel === 'input'
    ? FARM_DIAGNOSTICS_LENS_WUE_TREND
    : FARM_DIAGNOSTICS_LENS_ROTATION_EFFICIENCY;

/** The `?dlens=` URL param resolved to a lens, falling back to the scope's default when absent or unrecognised. */
export const resolveDiagnosticsLensParam = (
  param: string | null,
  scopeLevel: InsightsScopeLevel | undefined
): FarmDiagnosticsLens =>
  VALID_LENSES.includes(param as FarmDiagnosticsLens)
    ? (param as FarmDiagnosticsLens)
    : getDefaultDiagnosticsLens(scopeLevel);
